function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { CssTrackedApp } from './CssTrackedApp';
import { SdkOptions } from '../common/SdkOptions';
export var emptyClientApplication = Object.freeze({
  mount: function mount() {
    return Promise.resolve();
  },
  unmount: function unmount() {
    return Promise.resolve();
  },
  bootstrap: function bootstrap() {
    return Promise.resolve();
  }
});
var _cache = /*#__PURE__*/new WeakMap();
var _registryApps = /*#__PURE__*/new WeakMap();
var _moduleLoader = /*#__PURE__*/new WeakMap();
var _delayCssRemoval = /*#__PURE__*/new WeakMap();
var _configRoot = /*#__PURE__*/new WeakMap();
var _sdkFactoryBuilder = /*#__PURE__*/new WeakMap();
var _getApp = /*#__PURE__*/new WeakMap();
var _getAppSpaCallbacks = /*#__PURE__*/new WeakMap();
export var BundleLoader = /*#__PURE__*/function () {
  function BundleLoader(configRoot, moduleLoader, sdkFactoryBuilder) {
    var _this = this;
    _classCallCheck(this, BundleLoader);
    _classPrivateFieldInitSpec(this, _cache, new WeakMap());
    _classPrivateFieldInitSpec(this, _registryApps, void 0);
    _classPrivateFieldInitSpec(this, _moduleLoader, void 0);
    _classPrivateFieldInitSpec(this, _delayCssRemoval, void 0);
    _classPrivateFieldInitSpec(this, _configRoot, void 0);
    _classPrivateFieldInitSpec(this, _sdkFactoryBuilder, void 0);
    _classPrivateFieldInitSpec(this, _getApp, function (appName) {
      var app = _classPrivateFieldGet(_configRoot, _this).getConfigForAppByName(appName);
      if (!app) {
        throw new Error("Unable to find requested app \"".concat(appName, "\" in Registry"));
      }
      return app;
    });
    _classPrivateFieldInitSpec(this, _getAppSpaCallbacks, function (appBundle) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _ref = arguments.length > 2 ? arguments[2] : undefined,
        sdkFactory = _ref.sdkFactory,
        cacheEnabled = _ref.cacheEnabled;
      // We do this to make sure that mainSpa function will be called only once
      if (_classPrivateFieldGet(_cache, _this).has(appBundle)) {
        return _classPrivateFieldGet(_cache, _this).get(appBundle);
      }
      var mainSpa = appBundle.mainSpa || appBundle["default"] && appBundle["default"].mainSpa;
      if (mainSpa !== undefined && typeof mainSpa === 'function') {
        var res = mainSpa(props, {
          sdkFactory: sdkFactory
        });
        _classPrivateFieldGet(_cache, _this).set(appBundle, res);
        return res;
      } else {
        if (appBundle["default"] && typeof appBundle["default"].mount === 'function') {
          return appBundle["default"];
        }
        return appBundle;
      }
    });
    _classPrivateFieldSet(_registryApps, this, configRoot.getConfigForApps());
    _classPrivateFieldSet(_delayCssRemoval, this, configRoot.isGlobalSpinnerEnabled());
    _classPrivateFieldSet(_moduleLoader, this, moduleLoader);
    _classPrivateFieldSet(_configRoot, this, configRoot);
    _classPrivateFieldSet(_sdkFactoryBuilder, this, sdkFactoryBuilder);
  }

  /**
   * Speculative preload of the JS bundle.
   * We don't care about result as we do it only to heat up browser HTTP cache
   *
   * @param {string} appName
   * @return void
   */
  return _createClass(BundleLoader, [{
    key: "preloadApp",
    value: function preloadApp(appName) {
      var app = _classPrivateFieldGet(_getApp, this).call(this, appName);
      if (!app.spaBundle) {
        return;
      }
      _classPrivateFieldGet(_moduleLoader, this)["import"](app.spaBundle)["catch"](function () {});
      if (app.wrappedWith) {
        this.preloadApp(app.wrappedWith);
      }
    }

    /**
     *
     * @param {string} appName
     * @param {boolean} options.injectGlobalCss to css with <link> element in <head>
     * @returns Promise<object> application
     */
  }, {
    key: "loadApp",
    value: function loadApp(appName) {
      var _this2 = this;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$injectGlobalCss = _ref2.injectGlobalCss,
        injectGlobalCss = _ref2$injectGlobalCss === void 0 ? true : _ref2$injectGlobalCss;
      var applicationConfig = _classPrivateFieldGet(_getApp, this).call(this, appName);
      if (!applicationConfig.spaBundle) {
        // it is SSR only app
        return Promise.resolve(emptyClientApplication);
      }
      return _classPrivateFieldGet(_moduleLoader, this)["import"](appName).then(function (appBundle) {
        var sdkInstanceFactory = _classPrivateFieldGet(_sdkFactoryBuilder, _this2).getSdkFactoryByApplicationName(appName);
        var rawCallbacks = _classPrivateFieldGet(_getAppSpaCallbacks, _this2).call(_this2, appBundle, applicationConfig.props, {
          sdkFactory: sdkInstanceFactory
        });
        var application = typeof applicationConfig.cssBundle === 'string' && injectGlobalCss !== false ? new CssTrackedApp(rawCallbacks, applicationConfig.cssBundle, {
          delayCssRemoval: _classPrivateFieldGet(_delayCssRemoval, _this2)
        }).getDecoratedApp() : rawCallbacks;
        return application;
      });
    }
  }, {
    key: "loadAppWithCss",
    value: function loadAppWithCss(appName) {
      var app = _classPrivateFieldGet(_getApp, this).call(this, appName);
      var waitTill = [this.loadApp(appName)];
      if (app.cssBundle) {
        waitTill.push(this.loadCss(app.cssBundle));
      }
      return Promise.all(waitTill).then(function (values) {
        return values[0];
      });
    }
  }, {
    key: "loadCss",
    value: function loadCss(url) {
      return _classPrivateFieldGet(_moduleLoader, this)["import"](url)["catch"](function (err) {
        //TODO: inserted <link> tags should have "data-fragment-id" attr. Same as Tailor now does
        //TODO: error handling should be improved, need to submit PR with typed errors
        if (typeof err.message !== 'string' || err.message.indexOf('has already been loaded using another way') === -1) {
          throw err;
        }
      });
    }
  }, {
    key: "unloadApp",
    value:
    /**
     *
     * @param {String} appName application name
     */
    function unloadApp(appName) {
      var moduleId = _classPrivateFieldGet(_moduleLoader, this).resolve(appName);
      var appBundle = _classPrivateFieldGet(_moduleLoader, this).get(moduleId);
      _classPrivateFieldGet(_cache, this)["delete"](appBundle);
      _classPrivateFieldGet(_moduleLoader, this)["delete"](moduleId);
    }
  }]);
}();